import type { FC, MouseEvent } from 'react';
import { Grid, Box, Typography, List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { IMediaLibraryVideoModel } from '@/shared/models/media-library/media-library-video.model';
import VideoListItem from '../VideoListItem';

interface IVideoListTabProps {
  videoData: IMediaLibraryVideoModel[];
  onClickListItem: (event: MouseEvent<HTMLElement>, item: IMediaLibraryVideoModel) => void;
}

const VideoListTab: FC<IVideoListTabProps> = ({ videoData, onClickListItem }) => {
  const { t } = useTranslation();

  if (!videoData || videoData.length === 0) {
    return (
      <Grid item xs={12}>
        <Box sx={{ mt: 5, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h4" color="secondary">
            {t('noVideosAvailable')}
          </Typography>
        </Box>
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <List>
        {videoData.map((el: IMediaLibraryVideoModel, key) => (
          <VideoListItem el={el} key={key} itemIndex={key} handleClickListItem={onClickListItem} />
        ))}
      </List>
    </Grid>
  );
};

export default VideoListTab;
